import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TEXT from "../../../utils/globalText";

const FieldForceTxnFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fieldForceTxnRequestError } = useSelector(
    (state) => state.fieldForceTransaction,
  );

  useEffect(() => {
    dispatch(disableSwitcher());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) value.forEach(recurse);
      else if (typeof value === "object" && value !== null)
        Object.values(value).forEach(recurse);
      else if (typeof value === "string") messages.push(value);
    };

    recurse(errors);
    return messages;
  };

  const errorMessages = fieldForceTxnRequestError
    ? extractErrorMessages(fieldForceTxnRequestError)
    : extractErrorMessages(
        JSON.parse(sessionStorage.getItem("fieldForceTxnRequestError")),
      );

  const createAccountHandler = () => {
    navigate(
      "/field_force_transaction_dashboard/create_field_force_transaction",
    );
  };

  const dashboardHandler = () => {
    navigate("/field_force_transaction_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: " Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];
  return (
    <StatusContainer
      status="error"
      title={"Field force transaction failed."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="Error details">
        <div className="flex flex-col">
          {errorMessages.length > GlobalConfiguration.lengthCheckZero ? (
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error message",
                  },
                ]}
              />
            ))
          ) : (
            <InfoCard
              bgColor="var(--negative-card)"
              variant="text"
              label={TEXT?.NOT_AVAILABLE}
              subLabel="Error message"
            />
          )}
        </div>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceTxnFailed;
